(function() { window.GUID_2cf07a72_ebde_49ce_af16_03fc51f4c2f2 = { getGuid: function() { return "2cf07a72-ebde-49ce-af16-03fc51f4c2f2"; } }; })();
//namespace CS.Controls {
//    export class BodyContext extends ControlBase {
//        public get ControlId(): string {
//            return this.UniqueInstanceId;
//        }
//        public get $Control(): JQuery {
//            return CS.DOM.$body;
//        }
//        protected OnControlInstantiation(params: any[]) {
//        }
//        protected OnDispose() {
//        }
//        protected OnBindEvents(registerDispose: (callback: IDisposableCallback) => void) {
//            //CS.Lag(this.UniqueInstanceId, 50, () => {
//            //    CS.DisposableHelper.onContentWillBeReplaced(this.$Control, this.UniqueNamespace, this);
//            //});
//        }
//        public RaiseError(error: CS.Ajax.IAjaxError) {
//            this.Trigger<CS.Ajax.IAjaxError>(BodyContext.EventNames.AjaxError, { jqueryEventObject: null, data: error });
//        }
//        public RaiseAjaxNavigationStarted(args: BodyContext.INavigationStartedEventArgs) {
//            this.Trigger(BodyContext.EventNames.AjaxNavigationStarted, { data: args, jqueryEventObject: null });
//        }
//        public RaiseAjaxNavigationCompleted(args: BodyContext.INavigationOccuredEventArgs) {
//            this.Trigger(BodyContext.EventNames.AjaxNavigationCompleted, { data: args, jqueryEventObject: null });
//        }
//        public RaiseFirstNavigationHandeled(args: Navigation.State) {
//            this.Trigger(BodyContext.EventNames.FirstNavigationHandeled, { data: args, jqueryEventObject: null });
//        }
//    }
//    export namespace BodyContext {
//        export class Events {
//            public static AjaxError(param: IEvent<BodyContext, CS.Ajax.IAjaxError>) {
//                RegisterEvent(BodyContext, EventNames.AjaxError, param);
//            }
//            public static AjaxNavigationStarted(param: IEvent<BodyContext, INavigationStartedEventArgs>) {
//                RegisterEvent(BodyContext, EventNames.AjaxNavigationStarted, param);
//            }
//            public static AjaxNavigationCompleted(param: IEvent<BodyContext, INavigationOccuredEventArgs>) {
//                RegisterEvent(BodyContext, EventNames.AjaxNavigationCompleted, param);
//            }
//            public static FirstNavigationHandeled(param: IEvent<BodyContext, Navigation.State>) {
//                RegisterEvent(BodyContext, EventNames.FirstNavigationHandeled, param);
//            }
//        }
//        export class EventNames {
//            public static AjaxError: string = "ajax-error";
//            public static AjaxNavigationStarted: string = "ajax-navigation-started";
//            public static AjaxNavigationCompleted: string = "ajax-navigation-completed";
//            public static AjaxNavigationSlow: string = "ajax-navigation-slow";
//            public static FirstNavigationHandeled: string = "first-navigation-handeled";
//        }
//        export interface INavigationStartedEventArgs extends Omit<INavigationOccuredEventArgs, "navigationContext"> { }
//        export interface INavigationSlowArgs extends INavigationStartedEventArgs {
//            isSlow: boolean;
//        }
//        export interface INavigationOccuredEventArgs {
//            source: Navigation.Source;
//            url: string;
//            data: any;
//            navigationContext: Navigation.Context;
//            /** This is to be able to compare 2 event (started / Completed / Error) */
//            callReference: CS.Types.Reference;
//        }
//    }
//}

//# sourceMappingURL=body-context.js.map
